import { Routes } from '@angular/router';

/** Development builds only: the tip UI gallery, to check every component and state against the prototype. */
export const TIP_DEV_ROUTES: Routes = [
  { path: 'dev/tip-ui', loadComponent: () => import('./dev/gallery').then((m) => m.PayGallery) },
];
